import { cloneDeep } from 'lodash-es';
import { newSendApiRequest } from './service-gateway';
import { removeSearchAllMLSFlag } from '../common/helpers/api';

const searchCriteriaData = (criteria, parameters = []) => {
    const cleanCriteria = removeSearchAllMLSFlag(cloneDeep(criteria));
    return [
        {
            parameter: 'aergo_search_criteria',
            value: JSON.stringify(cleanCriteria)
        },
        ...parameters
    ];
};

export const getProficiencyMetrics = async (criteria, parameters) => {
    const response = await newSendApiRequest(
        'Recruiting_agent_sold',
        searchCriteriaData(criteria, parameters),
        240000
    );
    return {
        recruitingSoldResponse: response?.results,
        recruitingSoldTotals: response?.totals,
        error: response?.error
    };
};

export const getNewProducers = async (criteria, parameters) => {
    const response = await newSendApiRequest(
        'Recruiting_agent_sold_new_producers',
        searchCriteriaData(criteria, parameters),
        300000
    );
    return {
        recruitingSoldResponse: response?.results,
        recruitingSoldTotals: response?.totals,
        error: response?.error
    };
};

export const getCoopAgents = async (criteria, parameters) => {
    const response = await newSendApiRequest(
        'Recruiting_agent_sold_coop_agents',
        searchCriteriaData(criteria, parameters),
        300000
    );
    return {
        recruitingSoldResponse: response?.results,
        recruitingSoldTotals: response?.totals,
        error: response?.error
    };
};

export const getAgentMovement = async criteria => {
    const response = await newSendApiRequest(
        'Agent_movement',
        searchCriteriaData(criteria),
        120000
    );
    return {
        results: {
            results: response?.results ?? [],
            agentsPerMonth: response?.agentsPerMonth ?? [],
        },
        totals: response?.totals ?? {},
        error: response?.error,
    };
};

export const getAgentMovementOfficeBreakdown = async criteria => {
    const response = await newSendApiRequest(
        'Agent_movement_office_breakdown',
        searchCriteriaData(criteria),
        120000
    );
    return {
        results: response?.results ?? [],
        summary: response?.summary ?? {},
        error: response?.error,
    };
};

export const getAgentBreakdown = async (criteria, params) => {
    const response = await newSendApiRequest(
        'Agent_breakdown',
        searchCriteriaData(criteria, params),
        120000
    );
    return {
        results: response?.results ?? [],
        totals: response?.totals ?? {},
        error: response?.error,
    };
};

export const getDecreasingProducers = async (criteria, parameters) => {
    const response = await newSendApiRequest(
        'Decreasing_producers',
        searchCriteriaData(criteria, parameters),
        120000
    );
    return {
        recruitingSoldResponse: response?.results,
        recruitingSoldTotals: response?.totals,
        error: response?.error
    };
};

export const getIncreasingProducers = async (criteria, parameters) => {
    const response = await newSendApiRequest(
        'Increasing_producers',
        searchCriteriaData(criteria, parameters),
        120000
    );
    return {
        recruitingSoldResponse: response?.results,
        recruitingSoldTotals: response?.totals,
        error: response?.error
    };
};
/**
 * Mock data for Today's Picks Tab.
 * TODO: Remove when API endpoint is ready.
 */
const mockTodaysPicksData = [
    { agentId: 'agent-001', firstName: 'Sarah', lastName: 'Johnson', officeName: 'Premier Realty Group', volume: 2450000, units: 12, projectedVolumeMin: 2800000, projectedVolumeMax: 3200000, projectedUnitsMin: 14, projectedUnitsMax: 18, likelihoodOfMovement: 'high' },
    { agentId: 'agent-002', firstName: 'Michael', lastName: 'Chen', officeName: 'Coastal Properties', volume: 1875000, units: 8, projectedVolumeMin: 2100000, projectedVolumeMax: 2500000, projectedUnitsMin: 10, projectedUnitsMax: 13, likelihoodOfMovement: 'medium' },
    { agentId: 'agent-003', firstName: 'Emily', lastName: 'Rodriguez', officeName: 'Summit Real Estate', volume: 3200000, units: 15, projectedVolumeMin: 3500000, projectedVolumeMax: 4000000, projectedUnitsMin: 17, projectedUnitsMax: 22, likelihoodOfMovement: 'high' },
    { agentId: 'agent-004', firstName: 'David', lastName: 'Thompson', officeName: 'Metro Homes LLC', volume: 1250000, units: 6, projectedVolumeMin: 1400000, projectedVolumeMax: 1800000, projectedUnitsMin: 7, projectedUnitsMax: 10, likelihoodOfMovement: 'low' },
    { agentId: 'agent-005', firstName: 'Jessica', lastName: 'Williams', officeName: 'Elite Property Advisors', volume: 2890000, units: 11, projectedVolumeMin: 3100000, projectedVolumeMax: 3600000, projectedUnitsMin: 13, projectedUnitsMax: 16, likelihoodOfMovement: 'high' },
    { agentId: 'agent-006', firstName: 'Robert', lastName: 'Martinez', officeName: 'Urban Living Realty', volume: 1650000, units: 7, projectedVolumeMin: 1900000, projectedVolumeMax: 2200000, projectedUnitsMin: 9, projectedUnitsMax: 12, likelihoodOfMovement: 'medium' },
    { agentId: 'agent-007', firstName: 'Amanda', lastName: 'Davis', officeName: 'Sunrise Properties', volume: 2100000, units: 9, projectedVolumeMin: 2400000, projectedVolumeMax: 2800000, projectedUnitsMin: 11, projectedUnitsMax: 14, likelihoodOfMovement: 'medium' },
    { agentId: 'agent-008', firstName: 'Christopher', lastName: 'Brown', officeName: 'Landmark Realty Services', volume: 1980000, units: 10, projectedVolumeMin: 2200000, projectedVolumeMax: 2600000, projectedUnitsMin: 12, projectedUnitsMax: 15, likelihoodOfMovement: 'low' },
];

export const getTodaysPicks = async () => {
    await new Promise(resolve => setTimeout(resolve, 300));
    return {
        results: mockTodaysPicksData,
        total: mockTodaysPicksData.length,
        error: null
    };
};
